import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { PopoverController } from 'ionic-angular';

import { TeaserModel } from './teaser.model';
import { PopoverInfo } from './teaser.popover';

@Component({
	selector: 'teaser-range',
	templateUrl: 'teaser-range.html',
})
export class TeaserRangeComponent {

	@Input() rangeModel: TeaserModel;
	@Input() docSpecial: boolean;
    @Output() dataChanged = new EventEmitter();

    hasError: boolean = false;
	selectType: string = 'popover';
	defaultVal: TeaserModel;

    constructor(
        public popoverCtrl: PopoverController,
		private changeDetectorRef: ChangeDetectorRef
	) {
    }

    ngOnChanges() {
        if (this.rangeModel){
			if (this.rangeModel.symbol == 'percent') {
				this.rangeModel.value = (this.rangeModel.values[0] / 10);
			}
			if (this.rangeModel.symbol == 'currency') {
				this.rangeModel.value = Math.round(this.rangeModel.value);
			}
			if (this.rangeModel.type == 'select') {
				this.rangeModel.value = this.rangeModel.values[0];
			}
			if (!this.defaultVal) {
				this.defaultVal = JSON.parse(JSON.stringify(this.rangeModel));
			}
        }
	}

    valuesChangedPercent(isInput:boolean){
        if (isInput){
            this.rangeModel.values[0] = this.rangeModel.value * 10;
        } else {
            this.rangeModel.value = this.rangeModel.values[0] / 10;
        }
        if ((this.rangeModel.value * 10) > this.rangeModel.values[2] || (this.rangeModel.value * 10) < this.rangeModel.values[1]){
            this.hasError = true;
        } else {
            this.hasError = false;
            this.dataChanged.emit();
        }
        this.changeDetectorRef.detectChanges();
    }

	valuesChanged() {
		if (this.rangeModel.values[0] === null || this.rangeModel.values[0] === undefined || this.rangeModel.values[0] === NaN) {
			this.rangeModel.values[0] = 0;
			this.rangeModel.value = this.rangeModel.values[0];
		} else {
			this.rangeModel.values[0] = String(this.rangeModel.values[0]);
			this.rangeModel.value = this.rangeModel.values[0];
		}

        if (this.rangeModel.value > this.rangeModel.values[2] || this.rangeModel.value < this.rangeModel.values[1]) {
            this.hasError = true;
        } else {
            this.hasError = false;
            this.dataChanged.emit();
        }
        this.changeDetectorRef.detectChanges();
    }

    openInfo(myEvent, data) {
		let isDoc = this.rangeModel.id == 'profilGvsAltersrenteMtl' && this.docSpecial ? 'showDoc' : '';
		let popover = this.popoverCtrl.create(PopoverInfo, { infoData: data, isDoc: (isDoc != '') }, {cssClass: isDoc });
        popover.present({
            ev: myEvent
        });
    }

    formatNumber(num){
        num = parseFloat(num).toFixed(0);
        this.rangeModel.values[0] = num;
    }

    onKey($event){
		if ($event.key == "Backspace" && ($event.srcElement.value == 0 || $event.srcElement.value == '')){
			$event.preventDefault();
		}
		let num = $event.srcElement.value.replace(/,/g, ".");
		this.rangeModel.value = parseFloat(num);
    }

	onBlur($event){
		if (this.rangeModel.value === null || this.rangeModel.value === undefined ||  this.rangeModel.value === NaN ){
			this.rangeModel = JSON.parse(JSON.stringify(this.defaultVal));
			this.changeDetectorRef.detectChanges();
		}
    }

    isIE(){
        return ((navigator.appName == 'Microsoft Internet Explorer') || ((navigator.appName == 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) != null)));
    }
}



// WEBPACK FOOTER //
// ./src/components/teaser/teaser.components.ts